import { render } from "./Map.vue?vue&type=template&id=0ec5b31c"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__